var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalcBook = function SvgCalcBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 95,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "M103.982 94.726v-94H38.561v94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M98.857 13.57H44.48v5.518h54.377zM95.898 23.898H47.206v5.107h48.692z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43.744,
    height: 57.348,
    x: 0.736,
    y: 37.378,
    fill: "#D9D9D9",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 6.133,
    y: 57.346,
    fill: "#fff",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 6.133,
    y: 68.816,
    fill: "#fff",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 6.133,
    y: 80.285,
    fill: "#fff",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 17.807,
    y: 57.346,
    fill: "#fff",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 17.807,
    y: 68.816,
    fill: "#fff",
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 17.807,
    y: 80.285,
    fill: "#fff",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 29.475,
    y: 57.348,
    fill: "#fff",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 29.475,
    y: 68.817,
    fill: "#fff",
    rx: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 29.475,
    y: 80.286,
    fill: "#169B62",
    rx: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 37.208,
    height: 11.603,
    x: 4.004,
    y: 41.647,
    fill: "#848484",
    rx: 1
  })));
};
export { SvgCalcBook as ReactComponent };
export default __webpack_public_path__ + "images/calc-book.svg";